export default __webpack_public_path__ + "static/media/icon_photo-outlined copy.c3b50d20.svg";